export enum PackingTypeEnum {
  NONE = "NONE",
  STACKABLE = "STACKABLE",
  TURNABLE = "TURNABLE",
  STACKABLE_TURNABLE = "STACKABLE_TURNABLE",
}
